import { OrdenesCompra } from "../compras/ordenes-compra.interface";
import { BODEGAS, Ubicaciones } from "../inventario";
import { IDataMovimientoInventario } from "../movimiento-inventario";
import { MaterialTransferido } from "./producto.interface";
import { User } from "./user.interface";

//Ingreso Inventario
export interface IIngresoInventario {
  count: number;
  numero_paginas: number | undefined;
  next: string | undefined;
  num_pages: string | undefined;
  previous: string | undefined;
  data: IDataTrasladoInventario[];
}
export type IIngresoInventarioById = {
  code: number
  status: string
  message: string
  data: IDataIngresoInventario
}
export interface IDataIngresoInventario {
  id_ingreso_inventario: string
  codigo: string
  numero_referencia: string
  productos: any[]
  fecha: any
  estado: boolean
  fecha_creacion: string
  fecha_modificacion: string
  bodega: string
  bodega_data: BODEGAS
  ubicacion: string
  ubicacion_data: Omit<Ubicaciones, 'bodega_data'>
  solicitud_ingreso: any
  unidad_transporte: string
  //*
  orden_compra_isnull: boolean;
  numero_factura: number
  numero_guia_remision: number
  url_pdf: string
  estado_procesamiento?: 'PENDIENTE' | 'PROCESANDO' | 'COMPLETADO' | 'ERROR' | null
  error_mensaje?: string | null
  task_id?: string | null
  movimiento_inventario_data?: IDataMovimientoInventario[] | null
  observaciones: {
    observacion_1: string
  }
}

export interface IDataIngresoInventarioParams extends Partial<IDataIngresoInventario> {
  page?: number;
  page_size?: number;
}
//Solicitud Traslado Inventario
export interface ISolicitudTrasladoInventario {
  count: number;
  numero_paginas: number | undefined;
  next: string | undefined;
  num_pages: string | undefined;
  previous: string | undefined;
  data: IDataSolicitudTraslado[];
}

export interface IDataSolicitudTraslado {
  id_solicitudtraslado: string
  user: User
  motivo_rechazo_data: any
  bodega_origen_data: BODEGAS
  bodega_destino_data: BODEGAS
  ubicacion_origen_data: Ubicaciones
  ubicacion_destino_data: Ubicaciones
  codigo?: string
  numero_referencia?: string
  productos: any[]
  estado_solicitud: string
  observaciones: Observaciones
  estado: boolean
  fecha_creacion: string
  fecha_modificacion: string
  bodega_origen: string
  bodega_destino: string
  ubicacion_origen: string
  ubicacion_destino: string
  motivo_rechazo: any
  motivo: string
  unidad_transporte: string

  //
  solicitud_transferencia?: string | null;
  fecha: string;

  //aux
  concepto: string;
  url_pdf_recibido: string;
}

export interface IDataSolicitudTrasladoParams extends Partial<IDataSolicitudTraslado> {
  page?: number;
  page_size?: number;
}

//Traslado Inventario
export interface ITrasladoInventario {
  count: number;
  numero_paginas: number | undefined;
  next: string | undefined;
  num_pages: string | undefined;
  previous: string | undefined;
  data: IDataTrasladoInventario[];
}

export interface IDataTrasladoInventario {
  id_traslado_inventario: string;
  codigo: string
  numero_referencia: string
  productos: MaterialTransferido[]
  //estado_solicitud: string

  bodega_origen_data: BODEGAS
  bodega_destino_data: BODEGAS
  ubicacion_origen_data: Ubicaciones
  ubicacion_destino_data: Ubicaciones
  solicitud_transferencia: string; //codigo de solicitud de traslado
  fecha: string;
  estado: boolean
  bodega_origen: string
  bodega_destino: string
  ubicacion_origen: string
  ubicacion_destino: string
  user: string | null
  motivo_rechazo: string
  motivo: string
  unidad_transporte: string

  solicitud_transferencia_data: IDataSolicitudTraslado

  url_pdf: string | null
  id_ingreso_inventario?: string
  //auxiliar_factura
  bodega_data?: BODEGAS
  ubicacion_data?: Ubicaciones
  fecha_creacion: string
  orden_compra_data?: OrdenesCompra
  nomenclatura: string
  orden_compra: string
  observaciones: {
    observaciones_1: string
  } | null

  fecha_modificacion: string
  movimiento_inventario_data: IDataMovimientoInventario[] | null
  solicitado_por: string | null
}

export interface ITrasladoInventarioParams extends Partial<IDataTrasladoInventario> {
  page?: number;
  page_size?: number;
}

//Form-----

export interface IngresoInventarioForm {
  bodega: string | null;
  ubicacion: string;
  solicitud_ingreso?: string | null;
  motivo: string;
  unidad_transporte: string;
  observacion_1?: string;
  user?: string;
  productos?: MaterialTransferido[];
  observaciones?: any;
  fecha_actual_fronted?: string
  bodega_nombre?: string;
  ubicacion_nombre?: string;

  // reingreso
  observacion_emisor?: string;
  motivo_emisor?: string;
}

export interface ISolicitudTrasladoForm {
  bodega_origen: string;
  bodega_destino: string;
  ubicacion_origen: string | null;
  ubicacion_destino: string | null;
  motivo?: string;
  codigo?: string
  user?: string;
  productos?: any;
  estado_solicitud?: string;
  observaciones?: Observaciones;
  unidad_transporte?: string;
  solicitado_por: string;
  fecha_actual_fronted?: string;

  //aux
  observacion_1?: string
  numero_referencia?: string;
  fecha_solicitud_transferencia?: string; //Pendiente backend
  bodega_origen_externa?: boolean
  bodega_destino_externa?: boolean
  es_transito?: boolean
  traslado_inicial?: string | null
  fecha?: string
  estado_transitoinventario?: string
  id_notificacion_inventario?: string | null
  solicitud_egreso?: string
  correo_diferencia?: string
}

///
export enum EnumChoiceOptions {
  productos = 'PRODUCTO',
  numero_factura = 'NUMERO FACTURA',
  numero_guia_remision = 'NUMERO REMISION'
}
//Herencia
interface Observaciones {
  observaciones_1?: string;
}

